'use client';

import { Button } from '../../atoms/button/button';
import {
	TelemetryChart,
	type TelemetryChartProps,
} from '../../charts/telemetry-chart/telemetry-chart';
import { ExplodeButton } from '../../molecules/explode-button/explode-button';

export interface MeterCurveViewProps extends TelemetryChartProps {
	error?: string | null;
	onRetry: () => void;
	onExplode?: () => void;
}

export function MeterCurveView({ error, onRetry, onExplode, ...chart }: MeterCurveViewProps) {
	return (
		<section
			aria-label="Curva di carico"
			className="space-y-4 rounded-xl border border-border bg-card p-4 sm:p-5"
		>
			<div className="flex items-center justify-between gap-3">
				<h2 className="text-base font-semibold text-text">Curva di carico</h2>
				{onExplode && (
					<ExplodeButton
						label="Apri il punto di connessione per livello di dato"
						onClick={onExplode}
					/>
				)}
			</div>
			{error ? (
				<div role="alert" className="flex flex-wrap items-center justify-between gap-3">
					<p className="text-sm text-danger">{error}</p>
					<Button type="button" variant="outline" size="sm" onClick={onRetry}>
						Riprova
					</Button>
				</div>
			) : (
				<TelemetryChart
					{...chart}
					emptyHint="Curva non disponibile. Verifica la copertura in Healthcheck."
				/>
			)}
		</section>
	);
}
